module.exports = __webpack_public_path__ + "static/img/ispy.7084caf2.png";